/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q7Inputs */

const en_formatter_faq_q7 = /** @type {(inputs: Formatter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does formatting preserve the order of my keys?`)
};

const ko_formatter_faq_q7 = /** @type {(inputs: Formatter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포매팅이 키 순서를 보존하나요?`)
};

const ja_formatter_faq_q7 = /** @type {(inputs: Formatter_Faq_Q7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整形はキーの順序を保ちますか`)
};

/**
* | output |
* | --- |
* | "Does formatting preserve the order of my keys?" |
*
* @param {Formatter_Faq_Q7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q7 = /** @type {((inputs?: Formatter_Faq_Q7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q7(inputs)
	if (locale === "ko") return ko_formatter_faq_q7(inputs)
	return ja_formatter_faq_q7(inputs)
});